export { default } from './FaqContentsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/services/FaqContentsService/index.js